/*
 * The sticky bar over the six systems: marks the system in view and,
 * when the bar scrolls sideways on small screens, keeps its link in sight.
 */
export function initSystemNav() {
  const nav = document.querySelector(".system-nav");
  if (!nav || !("IntersectionObserver" in window)) return;

  const bar = nav.querySelector(".wrap");
  const links = new Map(
    [...nav.querySelectorAll("a[href^='#']")].map(link => [link.hash.slice(1), link])
  );

  const reducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  function show(link) {
    if (bar.scrollWidth <= bar.clientWidth) return;
    const barBox = bar.getBoundingClientRect();
    const linkBox = link.getBoundingClientRect();
    bar.scrollBy({
      left: linkBox.left - barBox.left - (barBox.width - linkBox.width) / 2,
      behavior: reducedMotion ? "auto" : "smooth"
    });
  }

  // A system is current while it crosses the middle of the viewport
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const link = links.get(entry.target.id);
      if (entry.isIntersecting) {
        link.setAttribute("aria-current", "location");
        show(link);
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }, { rootMargin: "-50% 0px -50% 0px" });

  links.forEach((link, id) => {
    const section = document.getElementById(id);
    if (section) observer.observe(section);
  });
}
